export enum QuestionSubtype {
	SIMPLE = 'simple',
	MULTIPLE_CHOICE = 'multiple_choice',
	SCALE = 'scale',
	SURVEY_END = 'survey_end',
}

export enum FrequencyCappingType {
	PER_USER = 'per_user',
	PER_TITLE = 'per_title',
}

export enum SurveyState {
	DRAFT = 'draft',
	ACTIVE = 'active',
	INACTIVE = 'inactive',
}

export interface SurveyVariation {
	id: number;
	translation: string;
	translation_id: number;
}

export interface SurveyAnswer {
	element_id: number;
	element_subtype: 'simple' | 'free_text';
	followup_question_node_id: number;
	id: number;
	order: number;
	title_id?: string;
	poster?: string;
	variations: SurveyVariation[];
	intents?: Intent[];
}

export interface ProcessedSurveyAnswer {
	element_id: number;
	element_subtype: 'simple' | 'free_text';
	followup_question_node_id: number;
	id: number;
	order: number;
	title_id?: string;
	poster?: string;
	variation_id: number;
	translation: string;
	translation_id: number;
	intents?: Intent[];
}

export interface SurveyQuestion {
	answers: SurveyAnswer[];
	has_ordered_answers?: boolean;
	element_id: number;
	element_subtype: QuestionSubtype;
	id: number;
	order: number;
	variations: SurveyVariation[];
}

export interface ProcessedSurveyQuestion {
	has_ordered_answers?: boolean;
	element_id: number;
	element_subtype: QuestionSubtype;
	id: number;
	order: number;
	variation_id: number;
	translation: string;
	translation_id: number;
}

export interface SurveyObject {
	amount_answers: number;
	amount_questions: number;
	campaign_reference_id: number;
	campaign_reference_type: string;
	frequency_capping_type: FrequencyCappingType;
	id: number;
	is_closable: boolean;
	locale: string;
	name: string;
	push_campaign_id: number;
	questions: SurveyQuestion[];
	start_question_node_id: number;
	state: SurveyState;
	type: string;
	tagId?: number;
}

export interface Intent {
	id: number;
	technical_name: string;
}
